import { call } from "redux-saga/effects";
import { API_URL, sagaFunction } from "../_config";
import { CallApi } from "./api/callApi";

export function* getHires(action: any): any {
  const { status, job_id, candidate_name, from_date, to_date, page, per_page } = action.payload || {};
  let url = API_URL.HIRES.GET_HIRES;
  const params: string[] = [];
  if (status) {
    if (Array.isArray(status)) {
      status.forEach((s: string) => params.push(`status[]=${s}`));
    } else {
      params.push(`status[]=${status}`);
    }
  }
  if (job_id) params.push(`job_id=${job_id}`);
  if (candidate_name) params.push(`candidate_name=${encodeURIComponent(candidate_name)}`);
  if (from_date) params.push(`from_date=${from_date}`);
  if (to_date) params.push(`to_date=${to_date}`);
  if (page) params.push(`page=${page}`);
  if (per_page) params.push(`per_page=${per_page}`);
  if (params.length > 0) url += `?${params.join("&")}`;
  yield call(sagaFunction, action, CallApi.GET, url, {}, true);
}
